"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkTitles = exports.useTitle = exports.ShellContext = exports.DisplayModes = void 0;
const react_1 = require("react");
const extension_hooks_1 = require("./extension-hooks");
var DisplayModes;
(function (DisplayModes) {
    DisplayModes[DisplayModes["FullScreen"] = 0] = "FullScreen";
    DisplayModes[DisplayModes["FullScreenOverflowed"] = 1] = "FullScreenOverflowed";
    DisplayModes[DisplayModes["Padded"] = 2] = "Padded";
})(DisplayModes = exports.DisplayModes || (exports.DisplayModes = {}));
exports.ShellContext = (0, react_1.createContext)({ subTitle: [], setSubTitle: () => { }, setDisplayMode: () => { }, routeCrumb: undefined, setRouteCrumb: () => { } });
const useTitle = (title) => {
    const titlePrefix = (0, extension_hooks_1.useExtensions)('shell.title')[0];
    const { subTitle } = (0, react_1.useContext)(exports.ShellContext);
    const documentTitle = [titlePrefix, title];
    if (subTitle.length > 0) {
        documentTitle.push(...subTitle);
    }
    const stringTitle = documentTitle.join(' | ');
    (0, react_1.useEffect)(() => {
        document.title = stringTitle;
    }, [stringTitle]);
    return document.title;
};
exports.useTitle = useTitle;
// for pages rendered from the CorePage()
// - event wizard, call list wizard, form, campaign builder
const checkTitles = (crumbs, subTitles) => {
    if (crumbs.length === 1) {
        return [crumbs[0].title, ...subTitles];
    }
    let result = [];
    crumbs === null || crumbs === void 0 ? void 0 : crumbs.map(c => result.push(c.title));
    return [...result, ...subTitles];
};
exports.checkTitles = checkTitles;
